import { RESET_PASSWORD_SLUG, PROMOTION_SLUG_BY_TYPE, DEPOSIT_METHOD } from '~/constants'
import { AccountTabs } from '~/constants/account.ts'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import { useRuntimeConfig } from '#app'

let MAIN_CREDIT_UNIT: string = ''
try {
  const environment = useRuntimeConfig().public
  MAIN_CREDIT_UNIT = environment.MAIN_CREDIT_UNIT
} catch {
  /* empty */
}

export const modalList = {
  REGISTER_SUCCESS: {
    icon: '/assets/images/popup/register-success.png',
    title: 'Đăng Ký Thành Công',
    description:
      '<div class="desc">Chúc mừng Quý khách đã tạo thành công và nhận được ' +
      'nhiều gói khuyến mãi từ MIBET ' +
      '</div>',
    confirmButtonText: 'Xem khuyến mãi',
    confirmButtonLink: `${AccountTabs.PROMOTION}?tab=${PROMOTION_SLUG_BY_TYPE.WELCOME}`,
    cancelButtonText: 'Nạp tiền',
    cancelButtonLink: AccountTabs.DEPOSIT,
    customClass: ''
  },
  REGISTER_AGAIN: {
    icon: '/assets/images/popup/user-confirm.webp',
    title: 'Quý khách chưa hoàn&nbsp;thành&nbsp;đăng&nbsp;ký',
    description:
      '<div class="desc">Chỉ còn 1 chút nữa thôi.<br>' + 'Tiếp tục đăng ký và làm chủ cuộc chơi cùng MIBET' + '</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Tiếp tục đăng ký',
    cancelButtonLink: '',
    customClass: ''
  },
  EMAIL_SUCCESS: {
    icon: '/assets/images/popup/email-success.png',
    title: 'Gửi email thành công',
    description:
      '<div class="desc">Thông tin khôi phục mật khẩu đã được gửi tới</div>' + '<div class="popup-email">[EMAIL]</div>',
    confirmButtonText: '',
    confirmButtonLink: '',
    cancelButtonText: 'Trang chủ',
    cancelButtonLink: '/',
    customClass: 'one-btn reset-password-btn',
    iconClass: 'email-success'
  },
  CHANGE_PASS_SUCCESS: {
    icon: '/assets/images/popup/email-success.png',
    title: 'Đổi mật khẩu thành công',
    description: '<div class="desc">Quý khách vui lòng đăng nhập lại để tiếp tục</div>',
    confirmButtonText: '',
    confirmButtonLink: '',
    cancelButtonText: 'Đăng nhập lại',
    cancelButtonLink: '',
    customClass: 'one-btn reset-password-btn'
  },
  CHANGE_PASS_ERROR: {
    icon: '/assets/images/popup/change-pass-error.png',
    title: 'Đổi Mật Khẩu Thất Bại',
    description: '<div class="desc mb-1">Link đổi mật khẩu không hợp lệ</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Thử lại',
    cancelButtonLink: `/${RESET_PASSWORD_SLUG}`,
    customClass: ''
  },
  DEPOSIT_SUCCESS: {
    icon: '/assets/images/popup/deposit-success.png',
    title: 'Tạo Phiếu Nạp Thành Công',
    description:
      '<div class="desc mb-1">Bạn đã tạo thành công phiếu nạp 500.000VNĐ, xin vui lòng chờ để được xử lý</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Lịch sử giao dịch',
    cancelButtonLink: AccountTabs.HISTORY_TRANSACTION,
    customClass: ''
  },
  DEPOSIT_ERROR: {
    icon: '/assets/images/popup/error.webp',
    title: 'Nạp tiền thất bại',
    description:
      '<div class="desc mb-1">Đã có lỗi trong quá trình tạo giao dịch,<br>Vui lòng thử lại giao dịch khác.</div>',
    confirmButtonText: 'Liên hệ CSKH',
    confirmButtonLink: '',
    cancelButtonText: 'Thử lại',
    cancelButtonLink: AccountTabs.DEPOSIT,
    customClass: ''
  },
  LIMIT_REQUEST: {
    icon: '/assets/images/popup/alarm.png',
    title: 'Đã đạt giới hạn tạo phiếu',
    description: '<div class="desc mb-1">Quý khách vui lòng thử lại sau.</div>',
    confirmButtonText: 'Liên hệ CSKH',
    confirmButtonLink: '',
    cancelButtonText: 'Tôi đã hiểu',
    customClass: ''
  },
  DEPOSIT_TPAY_PROCESSING: {
    icon: '/assets/images/popup/transfer-processing.webp',
    title: 'Đang xử lý yêu cầu',
    description:
      '<div class="desc mt-2 pt-1"> Vui lòng đợi <strong>1–2 phút</strong> để hệ thống kiểm tra và xử lý. ' +
      'Quý khách có thể theo dõi tiến trình giao dịch tại mục "Lịch sử giao dịch".</div>',
    confirmButtonText: 'Tạo phiếu nạp mới',
    confirmButtonLink: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.T_PAY}`,
    cancelButtonText: 'Xem lịch sử giao dịch',
    cancelButtonLink: AccountTabs.HISTORY_TRANSACTION
  },
  DEPOSIT_QRPAY_PROCESSING: {
    icon: '/assets/images/popup/transfer-processing.webp',
    title: 'Đang xử lý yêu cầu',
    description:
      '<div class="desc mt-2 pt-1"> Vui lòng đợi <strong>1–2 phút</strong> để hệ thống kiểm tra và xử lý. ' +
      'Quý khách có thể theo dõi tiến trình giao dịch tại mục "Lịch sử giao dịch".</div>',
    confirmButtonText: 'Tạo phiếu nạp mới',
    confirmButtonLink: `${AccountTabs.DEPOSIT}&type=${DEPOSIT_METHOD.QR_PAY}`,
    cancelButtonText: 'Xem lịch sử giao dịch',
    cancelButtonLink: AccountTabs.HISTORY_TRANSACTION
  },
  WITHDRAW_ERROR: {
    icon: '/assets/images/popup/withdraw-error.png',
    title: 'Rút Tiền Thất Bại',
    description: '<div class="desc mb-1">Đã có lỗi trong quá trình giao dịch,<br>Vui lòng thử lại giao dịch khác</div>',
    confirmButtonText: 'Liên hệ CSKH',
    confirmButtonLink: '',
    cancelButtonText: 'Thử lại',
    cancelButtonLink: '',
    customClass: ''
  },
  WITHDRAW_PROMOTION: {
    icon: '/assets/images/popup/error.webp',
    title: 'Rút tiền thất bại',
    description: '<div class="desc mb-1">Bạn chưa hoàn thành đủ vòng cược để rút tiền</div>',
    confirmButtonText: 'Liên hệ CSKH',
    confirmButtonLink: '',
    cancelButtonText: 'Thử lại',
    cancelButtonLink: ''
  },
  WITHDRAW_CRYPTO_SUCCESS: {
    icon: '/assets/images/popup/email-success.png',
    title: 'Tạo Phiếu Rút Thành Công',
    description: '',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Lịch sử giao dịch',
    cancelButtonLink: AccountTabs.HISTORY_TRANSACTION,
    customClass: ''
  },
  CRYPTO_EXCHANGE_RATE_CHANGED_ERROR: {
    title: 'Tỉ giá USDT đã thay đổi',
    description: ''
  },
  CHANGE_CRYPTO_WALLET: {
    icon: '/assets/images/popup/icon-change-wallet.png',
    title: 'Thay đổi địa chỉ ví?',
    description: '<div class="desc mb-1">Thay đổi này sẽ áp dụng cho các lần giao dịch rút tiền tiếp theo</div>',
    confirmButtonText: 'Huỷ',
    cancelButtonText: 'Xác nhận',
    customClass: ''
  },
  CRYPTO_FLATFORM: {
    title: 'Sàn giao dịch USDT',
    description: ` <div class="flatform-grid">
      <a href="https://www.binance.com/vi" target="_blank">
        <img src="/assets/images/icons/flatform/binance.svg" />
      </a>
      <a href="https://coin12.com" target="_blank">
        <img src="/assets/images/icons/flatform/coin12.svg" />
      </a>
      <a href="https://www.coinbase.com/advanced-trade/spot/BTC-USD" target="_blank">
        <img src="/assets/images/icons/flatform/coinbase.svg" />
      </a>
      <a href="https://www.exness.com/vi" target="_blank">
        <img src="/assets/images/icons/flatform/exness.svg" />
      </a>
      <a href="https://www.gate.io/" target="_blank">
        <img src="/assets/images/icons/flatform/gate.svg" />
      </a>
      <a href="https://remitano.com/home/vn" target="_blank">
        <img src="/assets/images/icons/flatform/remitano.svg" />
      </a>
      <a href="https://www.htx.com/vi-vi/" target="_blank">
        <img src="/assets/images/icons/flatform/huobi.svg" />
      </a>
      <a href="https://www.kucoin.com/vi" target="_blank">
        <img src="/assets/images/icons/flatform/kucoin.svg" />
      </a>
      <a href="https://www.okx.com/vi" target="_blank">
        <img src="/assets/images/icons/flatform/okx.svg" />
      </a>
    </div>`
  },
  CRYPTO_FLATFORM_MB: {
    title: 'Sàn giao dịch USDT',
    description: ` <div class="flatform-grid is-mobile">
    <a href="https://www.binance.com/vi" target="_blank"><img src="/assets/images/icons/flatform/binance-mb.svg" /></a>
    <a href="https://coin12.com" target="_blank"><img src="/assets/images/icons/flatform/coin12-mb.svg" /></a>
    <a href="https://www.coinbase.com/advanced-trade/spot/BTC-USD" target="_blank">
      <img src="/assets/images/icons/flatform/coinbase-mb.svg" />
    </a>
    <a href="https://www.exness.com/vi" target="_blank"><img src="/assets/images/icons/flatform/exness-mb.svg" /></a>
    <a href="https://www.gate.io/" target="_blank"><img src="/assets/images/icons/flatform/gate-mb.svg" /></a>
    <a href="https://remitano.com/home/vn" target="_blank">
      <img src="/assets/images/icons/flatform/remitano-mb.svg" />
    </a>
    <a href="https://www.htx.com/vi-vi/" target="_blank"><img src="/assets/images/icons/flatform/huobi-mb.svg" /></a>
    <a href="https://www.kucoin.com/vi" target="_blank"><img src="/assets/images/icons/flatform/kucoin-mb.svg" /></a>
    <a href="https://www.okx.com/vi" target="_blank"><img src="/assets/images/icons/flatform/okx-mb.svg" /></a>
  </div>`
  },
  NOT_COMPLETED_BETTING_ROUND: {
    icon: '/assets/images/popup/error.webp',
    title: 'Chưa hoàn thành vòng cược',
    description: '<div class="desc mb-1">Vui lòng hoàn thành đủ số vòng cược cần thiết để tạo lệnh rút</div>',
    confirmButtonText: 'Xác nhận',
    confirmButtonLink: '',
    customClass: ''
  },
  INSUFFICIENT_BALANCE_ERROR: {
    icon: '/assets/images/popup/error.webp',
    title: 'Số dư không đủ',
    description: '<div class="desc mb-1">Đã có lỗi trong quá trình giao dịch, vui lòng thử lại</div>',
    confirmButtonText: 'Liên hệ CSKH',
    confirmButtonLink: '',
    cancelButtonText: 'Thử lại',
    cancelButtonLink: '',
    customClass: ''
  },
  LOGIN_EXPIRED: {
    icon: '/assets/images/popup/error.webp',
    title: 'Phiên đăng nhập hết hạn',
    description: '<div class="desc mb-1">Vui lòng đăng nhập lại để tiếp tục trải nghiệm</div>',
    confirmButtonText: '',
    confirmButtonLink: '',
    cancelButtonText: 'Đăng nhập',
    cancelButtonLink: '',
    customClass: 'one-btn'
  },
  ERROR_SYSTEM: {
    icon: '/assets/images/popup/system-error.png',
    title: 'Lỗi hệ thống',
    description: '<div class="desc mb-1">Đã xảy ra lỗi hệ thống,<br>vui lòng thử lại sau</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Liên hệ CSKH',
    cancelButtonLink: '',
    customClass: ''
  },
  GAME_MAINTENANCE: {
    icon: '/assets/images/popup/game-maintenance.png',
    title: 'Game đang bảo trì',
    description:
      '<div class="desc mb-1">Game này hiện đang được bảo trì.<br>' + 'Quý khách vui lòng chọn game khác.</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Sảnh game',
    cancelButtonLink: LOBBY_GAME_URLS.ALL_GAME,
    customClass: ''
  },
  GAME_PROMOTION: {
    icon: '/assets/images/popup/game-promotion.png',
    title: 'Quý khách đang sử dụng<br>' + 'khuyến mãi',
    description: '<div class="desc mb-1">Quý khách không thể chơi game này<br>' + 'do đang sử dụng khuyến mãi</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Xem khuyến mãi',
    cancelButtonLink: AccountTabs.REFUND,
    customClass: ''
  },
  GAME_PROMOTION_PC: {
    icon: '/assets/images/popup/game-promotion.png',
    title: 'Quý khách đang sử dụng khuyến mãi',
    description: '<div class="desc mb-1">Quý khách không thể chơi game này do đang sử dụng khuyến mãi</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Xem khuyến mãi',
    cancelButtonLink: AccountTabs.REFUND,
    customClass: ''
  },
  CONFIRM_CANCEL_PROMOTION: {
    icon: '/assets/images/popup/warning.webp',
    title: 'Huỷ khuyến mãi?',
    description:
      '<div class="desc mb-1">Khi bấm "Huỷ khuyến mãi", tài khoản của Quý khách sẽ reset còn ' +
      `<span class="color-red-light">0 ${MAIN_CREDIT_UNIT}</span> (Bao gồm tiền Nạp & Khuyến mãi)</div>`,
    confirmButtonText: 'Để sau',
    confirmButtonLink: '',
    cancelButtonText: 'Hủy khuyến mãi',
    cancelButtonLink: '',
    customClass: ''
  },
  CANCEL_PROMOTION_FAILED: {
    icon: '/assets/images/popup/error.webp',
    title: 'Huỷ khuyến mãi thất bại',
    description: '<div class="desc mb-1">Quý khách không thể huỷ khuyến mãi khi vé cược chưa kết thúc</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Chi tiết khuyến mãi',
    cancelButtonLink: AccountTabs.REFUND,
    customClass: ''
  },
  TRASFER_WALLET_SUCCESS: {
    icon: '/assets/images/popup/email-success.png',
    title: 'Tạo phiếu chuyển thành công',
    description:
      '<div class="desc">Yêu cầu của Quý khách đang được xử lý.' +
      '<br />Chúng tôi sẽ cập nhật trạng thái trong lịch sử giao dịch.</div>',
    confirmButtonText: 'Trang chủ',
    confirmButtonLink: '/',
    cancelButtonText: 'Lịch sử giao dịch',
    cancelButtonLink: AccountTabs.HISTORY_TRANSACTION
  }
}
